// extracted by mini-css-extract-plugin
export var marginNegative = "_7a-5 _7a-3 _7a-1";
export var marginPositive = "_7a-4 _7a-3 _7a-1";
export var modalContent = "_7a-6";
export var samplesTable = "_7a-8";
export var samplesTableContainer = "_7a-7";
export var statBox = "_7a-a";
export var tableCell = "_7a-1";
export var tableCellCenter = "_7a-2 _7a-1";
export var tableCellRight = "_7a-3 _7a-1";
export var tableHeader = "_7a-0";
export var trackingNumber = "_7a-9";